import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_URL } from '../utils/constants';

export default function VerifyEmailPage() {
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const token = new URLSearchParams(location.search).get('token');

  useEffect(() => {
    const verify = async () => {
      if (!token) { setStatus('error'); setMessage('Invalid or missing verification token'); return; }
      try {
        const fd = new FormData();
        fd.append('token', token);
        const res = await fetch(`${API_URL}/verify-email`, { method: 'POST', body: fd });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail || 'Verification failed');
        setStatus('success');
        setMessage(data.message || 'Email verified successfully!');
      } catch (e) {
        setStatus('error');
        setMessage(e.message);
      }
    };
    verify();
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', background: '#050516', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
      <div style={{ background: '#0f172a', border: '1px solid #1e293b', borderRadius: 16, padding: 40, width: '100%', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ color: '#6366f1', fontWeight: 800, fontSize: 24, marginBottom: 24 }}>SPECTRAINE</div>

        {status === 'verifying' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
            <h2 style={{ color: '#e2e8f0', margin: '0 0 8px' }}>Verifying your email...</h2>
            <p style={{ color: '#475569', fontSize: 13 }}>Please wait a moment</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ color: '#10b981', margin: '0 0 8px' }}>Email Verified!</h2>
            <p style={{ color: '#94a3b8', fontSize: 14, marginBottom: 24 }}>{message}</p>
            <button
              onClick={() => navigate('/')}
              style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}
            >
              Go to Login →
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
            <h2 style={{ color: '#ef4444', margin: '0 0 8px' }}>Verification Failed</h2>
            <p style={{ color: '#94a3b8', fontSize: 14, marginBottom: 24 }}>{message}</p>
            <button
              onClick={() => navigate('/')}
              style={{ background: '#334155', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}
            >
              ← Back to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}